<div class="dv-product_compositions {{basicDivClass}} {{addDivClass}}" id="{{idDivCompo}}" >
    <span class="k-icon k-font-icon icon-chemistry" title ="{{PopinTooltip}}">      
    </span>
    <div class="dv-compositions" title ="{{PopinTooltip}}">
          <label class="lblProductCompos">
              {{ProductCompositionsText}}
          </label>
          <label class="lblProductComposUnit">
              {{ProductCompoUnitText}}
          </label>
    </div>
</div>